import { Component, OnInit, HostListener } from '@angular/core';

declare var myExtObject: any;

@Component({
  selector: 'app-preference',
  templateUrl: './preference.component.html',
  styleUrls: ['./preference.component.scss']
})
export class PreferenceComponent implements OnInit {
  vlue: any;
  lng: any;
  lng2: string;
  test: string;
  vlue2: string;
  vlue3: string;
  country: any;
  state: string;
  langue: string;
  test1: string;
  test2: string;
  seletedValue: string;
  selected: string;




  constructor() {

    this.test = localStorage.getItem("country")
    this.test1 = localStorage.getItem("state")
    this.test2 = localStorage.getItem("langue")



   }

  ngOnInit(): void {
 this.seletedValue ='ES'
   this.selected = 'option1';
  }



  getvlue(){

    this.vlue = (<HTMLInputElement>document.getElementById('countries_states2')).value;
    this.vlue2 = (<HTMLInputElement>document.getElementById('state')).value;
    this.vlue3 = (<HTMLInputElement>document.getElementById('langue')).value;
    this.country = this.vlue
    this.state = this.vlue2
    this.langue = this.vlue3
//console.log(this.langue +"fr_FR")

    localStorage.setItem('country', this.country);
    localStorage.setItem('state', this.state);
    localStorage.setItem('langue', this.langue);
    let mail = localStorage.getItem("country");
    //console.log('your email id is', mail);


    this.test = localStorage.getItem("country")
    this.test1 = localStorage.getItem("state")
    this.test2 = localStorage.getItem("langue")
    location.reload()

  }





}
